var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMascotAnimated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eCd4XghG6af1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 152 226",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.5649,40.8506c-3.1911,23.549,10.8779,44.8963,10.8779,44.8963s19.2429-16.8333,22.434-40.3823C100.068,21.8155,85.9987,0.468304,85.9987,0.468304s-19.2428,16.833196-22.4338,40.382296Z",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2452,61.6224C46.2766,80.8021,71.2168,86.4261,71.2168,86.4261s2.1909-25.4725-11.8405-44.6521-38.9716-24.8037-38.9716-24.8037-2.1909,25.4724,11.8405,44.6521Z",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72,224.313c39.765,0,72-32.236,72-72c0-39.765-32.235-72.0004-72-72.0004-39.7645,0-72,32.2354-72,72.0004c0,39.764,32.2355,72,72,72Z",
    fill: "#7199ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2431,42.4592c.7735,23.7516-15.3987,43.5532-15.3987,43.5532s-17.4263-18.7074-18.1998-42.459s15.3987-43.553278,15.3987-43.553278s17.4263,18.707378,18.1998,42.459078Z",
    fill: "#7199ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6824,42.8934C66.7107,59.4698,68.7905,84.9515,68.7905,84.9515s-25.5284-1.3938-42.5567-17.9702-19.10819-42.0581-19.10819-42.0581s25.52849,1.3939,42.55679,17.9702Z",
    fill: "#7199ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "eCd4XghG6af7",
    d: "M69,181.312c20.4345,0,37-16.565,37-37c0-20.434-16.5655-37-37-37s-37,16.566-37,37c0,20.435,16.5655,37,37,37Z",
    fill: "#f2f2f2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "eCd4XghG6af8",
    d: "M69,156c6.6274,0,12-5.373,12-12s-5.3726-12-12-12-12,5.373-12,12s5.3726,12,12,12Z",
    transform: "translate(.00001 0)",
    fill: "#3f3d56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotAnimated);
export default __webpack_public_path__ + "static/media/mascot_animated.705e28a22a0b0b7cd8a26e556fbb42b5.svg";
export { ForwardRef as ReactComponent };